import {
  List,
  Paper,
  Progress,
  Stack,
  Text,
  ThemeIcon,
  Title,
} from "@mantine/core";
import type { ReactElement } from "react";
import { useTranslation } from "react-i18next";

import type {
  AcceptanceItemResponse,
  AcceptanceStatus,
} from "../features/acceptance/api";

// Acceptance-чек-лист эпика с прогрессом (N done / M); источник —
// GET /tasks/{id}/acceptance. Показывается эпику в любом статусе, кроме awaiting_plan_approval.
// TODO(#1963): детей эпика HTTP не отдаёт; блок подзадач вернуть, когда
// решён их источник.
//
// «Готовый» пункт — status done или na (оба не блокируют закрытие,
// см. acceptance_item-модель). Прогресс = доля готовых.
export function DecompositionChecklist({
  acceptanceItems,
}: {
  readonly acceptanceItems: readonly AcceptanceItemResponse[];
}): ReactElement {
  const { t } = useTranslation();
  const total = acceptanceItems.length;
  const doneCount = acceptanceItems.filter(
    (item) => item.status === "done" || item.status === "na",
  ).length;
  const percent = total > 0 ? Math.round((doneCount / total) * 100) : 0;

  return (
    <Paper withBorder p="md">
      <Stack gap="sm">
        <Title order={3}>{t("task.checklistTitle")}</Title>

        {total > 0 ? (
          <Stack gap="xs">
            <Text size="sm" c="dimmed">
              {t("task.checklistProgress", {
                done: doneCount,
                total,
              })}
            </Text>
            <Progress value={percent} aria-label={t("task.checklistTitle")} />
            <List spacing="xs">
              {acceptanceItems.map((item) => (
                <List.Item
                  key={item.id}
                  icon={
                    <ThemeIcon
                      color={acceptanceColor(item.status)}
                      size={20}
                      radius="xl"
                    >
                      <Text size="xs">{acceptanceMark(item.status)}</Text>
                    </ThemeIcon>
                  }
                >
                  {item.text}
                </List.Item>
              ))}
            </List>
          </Stack>
        ) : (
          <Text c="dimmed">{t("task.checklistNoItems")}</Text>
        )}
      </Stack>
    </Paper>
  );
}

function acceptanceColor(status: AcceptanceStatus): string {
  if (status === "done") {
    return "green";
  }
  if (status === "na") {
    return "gray";
  }
  return "blue";
}

function acceptanceMark(status: AcceptanceStatus): string {
  if (status === "done") {
    return "✓";
  }
  if (status === "na") {
    return "–";
  }
  return "•";
}
